import includes from 'lodash/includes'
import { OrderStatusEnum } from '@ztechapps/common.contract'

/**
 * True while an order's status still allows editing — up to and including Packing, since the
 * order hasn't shipped yet and the customer can still go through checkout to adjust the address /
 * delivery date (matches isPostShipmentPayable's notion of "before shipment" in this same module).
 */
export const isOrderStatusEditable = (status: string): boolean =>
  includes(
    [
      OrderStatusEnum.InCart,
      OrderStatusEnum.Quotation,
      OrderStatusEnum.Order,
      OrderStatusEnum.InProgress,
      OrderStatusEnum.ReadyForPayment,
      OrderStatusEnum.Packing,
    ],
    status
  )
